import React from "react";
// import { GetStaticProps } from "next";
import { Util } from "@xt/xtbase";
const { getOrigin } = Util;
import { get_tdk } from "api/server/tdk";

import Layout from "components/Layout";
import Main from "components/Pages/academy";

interface Props {
  tdk?: any;
  resolvedUrl: string;
}

const Academy: React.FC<Props> = () => {
  return (
    // <Layout>
      <Main />
    // </Layout>
  );
};

export default Academy;

